import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button } from '@/comps/primitives/button';
import DatePicker from 'react-multi-date-picker';
import DateObject from 'react-date-object';
import { DATE_FORMAT_HUMAN } from '@/constants/date.constants';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import transition from 'react-element-popper/animations/transition';
const ANIMATIONS = [transition({
  duration: 300,
  from: 35
})];
type Props = {
  onClose: () => void;
  onChange: (value: DateObject[] | undefined) => void;
  initialValue?: DateObject[] | undefined;
};
export const ChartDateRange = t0 => {
  const $ = _c(23);
  const {
    onChange,
    onClose,
    initialValue
  } = t0;
  const datePickerRef = useRef(null);
  const [value, setValue] = useState(undefined);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      datePickerRef.current?.closeCalendar();
      setValue(undefined);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onManuallyCloseDatePicker = t1;
  let t2;
  if ($[1] !== onChange || $[2] !== value) {
    t2 = () => {
      onChange(value);
      onManuallyCloseDatePicker();
    };
    $[1] = onChange;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleApply = t2;
  let t3;
  let t4;
  if ($[4] !== initialValue) {
    t3 = () => {
      if (initialValue) {
        setValue(initialValue);
      }
    };
    t4 = [initialValue];
    $[4] = initialValue;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      datePickerRef.current?.openCalendar();
    };
    t6 = [];
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== onClose) {
    t7 = () => {
      onClose();
    };
    $[9] = onClose;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = newValue => {
      if (newValue && Array.isArray(newValue) && newValue.length == 2) {
        const start = new Date(newValue[0].valueOf());
        const end = new Date(newValue[1].valueOf());
        const range = [new DateObject(start), new DateObject(end)];
        setValue(range);
      } else {
        setValue(newValue as DateObject[] | undefined);
      }
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = new Date();
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Button onClick={e => {
      e.stopPropagation();
      onManuallyCloseDatePicker();
    }} size="sm" variant="outline">Cancel</Button>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== handleApply) {
    t11 = e_0 => {
      e_0.stopPropagation();
      handleApply();
    };
    $[14] = handleApply;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = !value?.[0] || !value?.[1];
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <div className="rmdp-footer flex justify-end gap-3 p-3 pt-0">{t10}<Button onClick={t11} size="sm" disabled={t12}>Apply</Button></div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t7 || $[21] !== value) {
    t14 = <DatePicker ref={datePickerRef} onClose={t7} animations={ANIMATIONS} value={value} format={DATE_FORMAT_HUMAN} onChange={t8} range={true} maxDate={t9} rangeHover={true} arrow={false} render={_temp} calendarPosition="bottom-left" zIndex={1300}>{t13}</DatePicker>;
    $[19] = t13;
    $[20] = t7;
    $[21] = value;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
};
function _temp() {
  return <></>;
}